import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection: React.FC = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary via-secondary to-brand-primary relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(0,168,204,0.15),transparent_50%)]" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="RocketLaunchIcon" size={20} className="text-accent" variant="solid" />
            <span className="text-sm font-cta font-semibold text-white">Ready to Get Started?</span>
          </div>
          
          <h2 className="font-headline font-bold text-3xl lg:text-5xl text-white mb-6 leading-tight">
            Let's Build Your Technology Success Story Together
          </h2>
          
          <p className="font-body text-lg lg:text-xl text-white/90 leading-relaxed mb-10 max-w-2xl mx-auto">
            Join hundreds of businesses that trust Centronics IT Soloutions to power their digital transformation and drive measurable results.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/contact"
              className="flex items-center space-x-2 px-8 py-4 bg-white hover:bg-white/90 text-primary rounded-lg font-cta font-semibold text-lg shadow-elevated hover:shadow-card transition-all duration-300 transform hover:scale-105 w-full sm:w-auto justify-center"
            >
              <Icon name="CalendarIcon" size={24} variant="outline" />
              <span>Schedule Free Consultation</span>
            </Link>
            
            <Link
              href="/services-overview"
              className="flex items-center space-x-2 px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-lg font-cta font-semibold text-lg border-2 border-white/30 transition-all duration-300 w-full sm:w-auto justify-center"
            >
              <Icon name="ArrowRightIcon" size={24} />
              <span>Explore Our Services</span>
            </Link>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-8 mt-12 pt-8 border-t border-white/20">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={24} className="text-success" variant="solid" />
              <span className="font-body text-white/90">No Long-Term Contracts</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ClockIcon" size={24} className="text-success" variant="solid" />
              <span className="font-body text-white/90">24/7 Support Available</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ShieldCheckIcon" size={24} className="text-success" variant="solid" />
              <span className="font-body text-white/90">100% Satisfaction Guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;